"use strict";

define('rs/abstract.content.controller',['require','exports','module','vertebrae','rs/helper','rs/header/header.controller','rs/errors','e3-modal','e3-common'],function (require, exports, module) {
  var Vertebrae = require('vertebrae');
  var helper = require('rs/helper');
  var HeaderController = require('rs/header/header.controller');
  var RSError = require('rs/errors');
  var E3Modal = require('e3-modal');
  var E3 = require('e3-common');
  var AbstractContentController = Vertebrae.Controller.extend({
    properties: ['appController', 'started'],
    contentName: 'undefined-content',
    observes: {
      'window-resize': 'resize'
    },
    events: {
      'view:ready': null
    },
    footer: true,
    initialize: function initialize(appController) {
      this._super();
      this.setAppController(appController);
      this._tableControllers = [];
    },
    checkPermission: function checkPermission(permission) {
      return this.getAppController().checkPermission(permission);
    },
    checkRole: function checkRole(role) {
      return this.getAppController().checkRole(role);
    },
    hasStarted: function hasStarted() {
      return this.getStarted();
    },
    bindToPropertyChange: function bindToPropertyChange(property, fn) {
      var sections = String(property).split('.'),
        obj = this,
        objPath = sections.slice(0, -1).join('.'),
        value = null,
        propertyName = sections.slice(-1).join(''),
        accessorFn = 'get' + E3.String.camelCase(propertyName);
      function triggerDataUpdate() {
        value = obj[accessorFn] ? obj[accessorFn]() : obj.get(propertyName);
        value = this.dataPropertyFormatter(property, value) || value;
        fn(value || '');
      }
      if (objPath) {
        obj = E3.Object.namespace(this, objPath);
      }
      if (!obj) {
        return;
      }
      this.listenTo(obj, 'change:' + propertyName, triggerDataUpdate);
      triggerDataUpdate.call(this);
    },
    dataPropertyFormatter: function dataPropertyFormatter(property, value) {
      return value;
    },
    viewIsAvailable: function viewIsAvailable() {
      if (this.footer && this.getView().renderFooter) {
        this.getView().renderFooter();
      }
      this.resize();
      this._setupTableControllers();
    },
    _setupTableControllers: function _setupTableControllers() {
      var tables = this._tableControllers,
        table = null,
        len = tables ? tables.length : 0,
        i = 0;
      for (i = 0; i < len; ++i) {
        table = tables[i];
        this._setupTableController(table);
      }
    },
    _setupTableController: function _setupTableController(controller) {
      var view = controller.getView(),
        that = this,
        listenRender = null,
        reSetup = null;
      reSetup = function reSetup() {
        that.getView()._removeWatchedTable(view);
        that._setupTableView(view);
      };
      listenRender = function listenRender() {
        that.listenTo(controller, 'view:render', reSetup);
      };
      if (view.isAvailable()) {
        this._setupTableView(view);
        listenRender();
      } else {
        that.listenToOnce(view, 'change:available', function () {
          that._setupTableView(view);
          listenRender();
        });
      }
    },
    _setupTableView: function _setupTableView(view) {
      this.getView()._setupTableViewScroll(view);
    },
    showLoading: function showLoading() {
      return app.request('dimmer', {
        legacy: true
      });
    },
    canLeaveContentController: function canLeaveContentController() {
      if (this.hasVolatileData()) {
        var discardText = this.getDiscardText(),
          buttons = [];
        buttons.push(discardText.refusal);
        if (discardText.cancel) {
          buttons.push(discardText.cancel);
        }
        buttons.push({
          text: discardText.confirmation,
          color: 'primary',
          icon: 'save'
        });
        return E3Modal.BtnMsgModal.show({
          title: 'Unsaved Changes',
          message: this.getVolatileDataMessage(),
          buttons: buttons
        }).bind(this).then(function (btn) {
          if (btn == discardText.cancel) {
            throw new Vertebrae.App.Errors.NavigationCancelled();
          } else if (btn == discardText.confirmation) {
            return this.requestPageSave();
          } else {
            return Promise.resolve();
          }
        })["catch"](function () {
          throw new Vertebrae.App.Errors.NavigationCancelled();
        });
      }
      return true;
    },
    unloadContentController: function unloadContentController() {
      return Promise.resolve();
    },
    requestPageSave: function requestPageSave() {},
    getDiscardText: function getDiscardText() {
      return {
        cancel: 'Cancel',
        confirmation: 'Save',
        refusal: "Don't Save"
      };
    },
    getHelpLink: function getHelpLink(id) {
      return this.getAppController().generateHelpLink(id);
    },
    getVolatileDataMessage: function getVolatileDataMessage() {
      return 'Would you like to save these changes before you leave the page?';
    },
    hasVolatileData: function hasVolatileData() {
      return false;
    },
    start: function start() {},
    registerTableController: function registerTableController(table) {
      this._tableControllers.push(table);
    },
    resize: function resize() {
      var view = this.getView();
      if (view && view.isAvailable() && view.resize) {
        view.resize();
      }
    },
    updateDocumentTitle: function updateDocumentTitle() {
      this.getAppController().updateTitle();
    },
    getDocumentTitle: function getDocumentTitle() {
      if (this.DocumentTitle) {
        return this.DocumentTitle;
      }
      return '';
    }
  }, {
    requiredPermissions: [],
    isAccessAllowed: function isAccessAllowed(personObj) {
      return personObj.supportsFeature(this.requiredFeature) && personObj.hasPermissions(this.requiredPermissions);
    }
  });
  module.exports = AbstractContentController;
});

